var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _polygon, _polyline, _polyline2, _path46, _path47, _path48, _path49, _path50, _path51;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-miterlimit:10;}.cls-1{stroke:#c3003f;stroke-width:2px;}.cls-2{stroke:#00046d;stroke-width:3px;}.cls-3{fill:#00046d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.26,61.63s.92-4.88,8.29-3.66,11.52-4.27,10.6-11.59,4.61-9.75,4.61-9.75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.55,58c7.37,1.22,11.52-4.27,10.6-11.59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.26,61.63s1-4.88,9-3.66,12.5-4.27,11.5-11.59a8.93,8.93,0,0,1,5-9.75"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "353.76 62.12 47.26 61.63 47.26 181.63 87.26 137.99 353.76 136.5 353.76 62.12"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "353.76 137.13 353.76 62.13 375.76 36.13 69.76 37.13 46.76 61.13"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "377.76 34.63 377.76 108.13 353.76 137.13"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.84,78.73c3.45,0,6.08.72,7.87,2.17a10.94,10.94,0,0,1,3.71,5.77,29.48,29.48,0,0,1,1,8v17.92a4.21,4.21,0,0,1-1.19,3,4.3,4.3,0,0,1-6,0,4.21,4.21,0,0,1-1.19-3V94.69a13.55,13.55,0,0,0-.6-4.17,5.73,5.73,0,0,0-2.13-3,7.41,7.41,0,0,0-4.41-1.12,9.25,9.25,0,0,0-4.73,1.12,7.69,7.69,0,0,0-2.94,3,8.63,8.63,0,0,0-1,4.17v17.92a4.21,4.21,0,0,1-1.19,3,4.3,4.3,0,0,1-6,0,4.17,4.17,0,0,1-1.19-3V83.7a4.18,4.18,0,0,1,1.19-3,4.32,4.32,0,0,1,6,0,4.22,4.22,0,0,1,1.19,3v3l-1-.21A13.34,13.34,0,0,1,83,83.94a16.88,16.88,0,0,1,2.8-2.55,14,14,0,0,1,3.64-1.93A12.83,12.83,0,0,1,93.84,78.73Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.35,78.73a4.07,4.07,0,0,1,3,1.19A4.18,4.18,0,0,1,153.55,83v29.61a4.21,4.21,0,0,1-1.19,3,4.3,4.3,0,0,1-6,0,4.17,4.17,0,0,1-1.19-3v-3.43l1.54.63a4,4,0,0,1-1,2.2,13.35,13.35,0,0,1-2.66,2.56,16.16,16.16,0,0,1-4,2.13,13.66,13.66,0,0,1-4.93.88,16,16,0,0,1-8.75-2.49,17.4,17.4,0,0,1-6.2-6.86,23.51,23.51,0,0,1,0-20.16,17.76,17.76,0,0,1,6.13-6.86,15.45,15.45,0,0,1,8.54-2.48,16.39,16.39,0,0,1,9.9,3.22,13.08,13.08,0,0,1,2.87,2.83,4.5,4.5,0,0,1,1,2.42l-2.52.91V83a4.18,4.18,0,0,1,1.19-3A4,4,0,0,1,149.35,78.73Zm-14.14,31.15a9.55,9.55,0,0,0,5.39-1.54,10.41,10.41,0,0,0,3.6-4.2,14.43,14.43,0,0,0,0-12,10.28,10.28,0,0,0-3.6-4.2,9.47,9.47,0,0,0-5.39-1.54A9.33,9.33,0,0,0,129.89,88a10.37,10.37,0,0,0-3.61,4.2,14.53,14.53,0,0,0,0,12,10.51,10.51,0,0,0,3.61,4.2A9.41,9.41,0,0,0,135.21,109.88Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M202.13,98.19a19.61,19.61,0,0,1-2.56,10.11,18.35,18.35,0,0,1-6.86,6.83,20.13,20.13,0,0,1-19.25,0,18.43,18.43,0,0,1-6.86-6.83,21.34,21.34,0,0,1,0-20.23,18.73,18.73,0,0,1,6.86-6.86,19.92,19.92,0,0,1,19.25,0,18.65,18.65,0,0,1,6.86,6.86A19.64,19.64,0,0,1,202.13,98.19Zm-8.4,0a12.71,12.71,0,0,0-1.44-6.2,10.62,10.62,0,0,0-3.85-4.09,10.49,10.49,0,0,0-10.71,0A10.69,10.69,0,0,0,173.88,92a12.82,12.82,0,0,0-1.43,6.2,12.63,12.63,0,0,0,1.43,6.12,10.72,10.72,0,0,0,3.85,4.1,10.49,10.49,0,0,0,10.71,0,10.65,10.65,0,0,0,3.85-4.1A12.52,12.52,0,0,0,193.73,98.19Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.46,111.07a3.9,3.9,0,0,1-.63-2.52,3.34,3.34,0,0,1,1.82-2.66,3.77,3.77,0,0,1,2.38-.6,4,4,0,0,1,2.45,1.3,16.5,16.5,0,0,0,4.27,3.15,12.55,12.55,0,0,0,5.6,1.12,18.16,18.16,0,0,0,2.31-.32,4.41,4.41,0,0,0,2.2-1.12,3.49,3.49,0,0,0,.95-2.69,3.06,3.06,0,0,0-1.05-2.45,8.73,8.73,0,0,0-2.77-1.54c-1.14-.42-2.41-.82-3.81-1.19s-2.93-.89-4.45-1.4a18.82,18.82,0,0,1-4.16-2,9.6,9.6,0,0,1-3.08-3.25,9.94,9.94,0,0,1-1.19-5.11,9.19,9.19,0,0,1,2-6,12.66,12.66,0,0,1,5.07-3.78,16.46,16.46,0,0,1,6.55-1.33,21.18,21.18,0,0,1,4.55.52A17.94,17.94,0,0,1,234,80.93a11.33,11.33,0,0,1,3.64,3,5.06,5.06,0,0,1,.91,2.52,3,3,0,0,1-1.33,2.66,3.38,3.38,0,0,1-2.45.73,3.67,3.67,0,0,1-2.31-.94,8.24,8.24,0,0,0-3.19-2.45,10.89,10.89,0,0,0-4.58-.91,12,12,0,0,0-2.28.24,4.6,4.6,0,0,0-2.13,1A3.82,3.82,0,0,0,220.4,92a7.82,7.82,0,0,0,2.83,1.54c1.19.4,2.46.78,3.82,1.16s2.82.81,4.27,1.33a17,17,0,0,1,4,2,9.68,9.68,0,0,1,2.94,3.25,10.35,10.35,0,0,1,1.12,5.08,9.2,9.2,0,0,1-2.1,6.09,13.25,13.25,0,0,1-5.25,3.81,16.87,16.87,0,0,1-6.44,1.3,24.91,24.91,0,0,1-8.26-1.44A14.26,14.26,0,0,1,210.46,111.07Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.66,79.43a4,4,0,0,1,3,1.22,4.22,4.22,0,0,1,1.19,3v17.78q0,7.41-4.13,11.76t-11.9,4.34q-7.77,0-11.87-4.34t-4.09-11.76V83.7a4.18,4.18,0,0,1,1.19-3,4.32,4.32,0,0,1,6,0,4.22,4.22,0,0,1,1.19,3v17.78c0,2.84.63,5,1.89,6.33s3.15,2.07,5.67,2.07,4.48-.69,5.74-2.07,1.89-3.49,1.89-6.33V83.7a4.18,4.18,0,0,1,1.19-3A4,4,0,0,1,277.66,79.43Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M322.25,79.43a4,4,0,0,1,3,1.22,4.22,4.22,0,0,1,1.19,3v17.78q0,7.41-4.13,11.76t-11.9,4.34q-7.77,0-11.87-4.34t-4.09-11.76V83.7a4.18,4.18,0,0,1,1.19-3,4.32,4.32,0,0,1,6,0,4.22,4.22,0,0,1,1.19,3v17.78c0,2.84.63,5,1.89,6.33s3.15,2.07,5.67,2.07,4.48-.69,5.74-2.07,1.89-3.49,1.89-6.33V83.7a4.18,4.18,0,0,1,1.19-3A4,4,0,0,1,322.25,79.43Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df2ef45f28525bf319d44bc2a4e18c21.svg";
export { ForwardRef as ReactComponent };